<template>
  <AccessHandler
    :requiredRoleGroups="roleGroups"
    @accessChanged="(a: boolean) => (hasAccess = a)"
  />
  <div class="financials-page" style="width: 100%">
    <MasterPage>
      <template v-if="hasAccess" v-slot:content>
        <header class="page__header--container clearfix">
          <h1 class="page__title--text pull-left">FINANCIALS</h1>
          <a
            class="header-help-link"
            target="_blank"
            href="https://cdn.jwplayer.com/previews/vpPybilI"
            ><font-awesome-icon icon="fa-solid fa-circle-question" /> Watch the
            payments tutorial</a
          >
        </header>
        <FinancialsView />
        <GlobalFooter />
      </template>
    </MasterPage>
  </div>
</template>

<script setup lang="ts">
import MasterPage from "../MasterPage.vue";
import { useMainStore } from "@/stores/useMainStore";
import GlobalFooter from "@/views/GlobalFooter.vue";
import FinancialsView from "./FinancialsView.vue";
import AccessHandler from "@/shared/access/AccessHandler.vue";
import {
  type RoleGroup,
  FinancialsEmulationGroup,
  IViewGroup,
} from "@/shared/access/RoleGroups";
import { ref } from "vue";

const main = useMainStore();

const roleGroups = [
  { roles: [...IViewGroup.roles, ...FinancialsEmulationGroup.roles] },
  {
    roles: [],
    validateRestrictionsAsync: async () => {
      return main.companySummary?.denials.every(
        (d) => !d.Financials || d.Financials.toUpperCase() !== "ALL"
      );
    },
  },
] as RoleGroup[];

const hasAccess = ref<boolean>(false);
</script>

<style scoped lang="scss">
.page {
  &__header--container {
    display: flex;
    align-items: center;
    margin-top: 30px;
    gap: 12px;
  }

  &__title--text {
    font-size: 24px;
    line-height: 28px;
    font-weight: 600;
    text-transform: uppercase;
  }
}

.header-help-link {
  text-decoration: none;
  &:hover {
    color: #0a58ca;
  }
}
</style>
